/* rhoneprints: glitchy cursor + little blips in the background */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;

  /* ---------- background: static scanlines drift, grain flickers ---------- */
  var base = document.createElement('style');
  base.textContent =
    '@keyframes gl-scan{to{background-position:0 300px}}' +
    '@keyframes gl-grain{0%,88%,100%{opacity:.05}90%{opacity:.11}93%{opacity:.03}96%{opacity:.09}}' +
    'body::after{animation:gl-scan 40s linear infinite}' +
    'body::before{animation:gl-grain 7s steps(1) infinite}';
  document.head.appendChild(base);

  /* ---------- background blips: tiny bars, pixels and the odd tear ---------- */
  var bc = document.createElement('canvas');
  bc.setAttribute('aria-hidden', 'true');
  bc.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:9996';
  document.body.appendChild(bc);
  var bx = bc.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  function bsize() {
    bc.width = window.innerWidth * dpr;
    bc.height = window.innerHeight * dpr;
    bx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  bsize();
  window.addEventListener('resize', bsize);

  var blips = [], brun = false, blast = 0;
  var BC = ['34,230,255', '255,47,208', '242,239,255', '255,233,74'];
  function bframe(now) {
    var dt = Math.min(now - blast, 50);
    blast = now;
    bx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    for (var i = blips.length - 1; i >= 0; i--) {
      var b = blips[i];
      b.t += dt;
      if (b.t >= b.life) { blips.splice(i, 1); continue; }
      var a = b.a * (1 - b.t / b.life);
      /* flicker on/off while alive */
      if (Math.random() < 0.25) a *= 0.3;
      if (b.img) {
        if (Math.random() < 0.15) continue;
        bx.globalAlpha = Math.min(1, a * 1.2);
        bx.drawImage(b.img, b.sx, b.sy, b.sw, b.sh, b.x, b.y, b.w, b.h);
        bx.globalAlpha = 1;
        continue;
      }
      bx.fillStyle = 'rgba(' + b.c + ',' + a.toFixed(3) + ')';
      bx.fillRect(b.x, b.y, b.w, b.h);
    }
    if (blips.length) requestAnimationFrame(bframe);
    else { brun = false; bx.clearRect(0, 0, window.innerWidth, window.innerHeight); }
  }
  function addBlip(o) {
    blips.push(o);
    if (!brun) { brun = true; blast = performance.now(); requestAnimationFrame(bframe); }
  }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pickC() { return BC[Math.floor(Math.random() * BC.length)]; }
  function spawn() {
    var W = window.innerWidth, H = window.innerHeight;
    var r = Math.random();
    if (r < 0.5) {
      /* thin horizontal bar */
      addBlip({ x: rnd(0, W - 60), y: rnd(0, H), w: rnd(30, 260), h: rnd(1, 3), c: pickC(), a: rnd(0.25, 0.5), t: 0, life: rnd(120, 260) });
    } else if (r < 0.85) {
      /* a few tiny pixels */
      var n = 2 + Math.floor(Math.random() * 4), px = rnd(0, W), py = rnd(0, H);
      for (var k = 0; k < n; k++) {
        var s = Math.random() < 0.5 ? 3 : 5;
        addBlip({ x: px + rnd(-40, 40), y: py + rnd(-20, 20), w: s, h: s, c: pickC(), a: rnd(0.3, 0.6), t: 0, life: rnd(150, 400) });
      }
    } else {
      /* full-width tear, very faint */
      addBlip({ x: 0, y: rnd(0, H), w: W, h: rnd(4, 18), c: pickC(), a: 0.07, t: 0, life: rnd(90, 180) });
    }
    setTimeout(spawn, rnd(350, 1300));
  }
  setTimeout(spawn, 1200);

  /* ---------- now and then a thin sliver of the art flashes up for a split second ---------- */
  var artImgs = [];
  function loadArt() {
    var list = (window.GL_ART || []).slice();
    list.sort(function () { return Math.random() - 0.5; });
    list.slice(0, 6).forEach(function (u) {
      var im = new Image();
      im.onload = function () { if (im.naturalWidth) artImgs.push(im); };
      im.src = u;
    });
  }
  function sliver() {
    if (artImgs.length) {
      var im = artImgs[Math.floor(Math.random() * artImgs.length)];
      var W = window.innerWidth, H = window.innerHeight;
      var vertical = Math.random() < 0.35, w, h;
      if (vertical) { w = rnd(24, 70); h = rnd(H * 0.3, H * 0.8); }
      else { w = rnd(W * 0.25, W * 0.7); h = rnd(14, 60); }
      var x = rnd(0, Math.max(1, W - w)), y = rnd(0, Math.max(1, H - h));
      var iw = im.naturalWidth, ih = im.naturalHeight, ar = w / h, sw, sh;
      if (ar > iw / ih) { sw = iw; sh = iw / ar; } else { sh = ih; sw = ih * ar; }
      var z = rnd(0.3, 1);
      sw *= z; sh *= z;
      var sx = rnd(0, Math.max(0, iw - sw)), sy = rnd(0, Math.max(0, ih - sh));
      var life = rnd(70, 170);
      addBlip({ img: im, sx: sx, sy: sy, sw: sw, sh: sh, x: x, y: y, w: w, h: h, a: 0.85, t: 0, life: life });
      /* a thin colored line right beside it, like a scan artifact */
      addBlip({ x: x, y: vertical ? y : y - 3, w: vertical ? 2 : w, h: vertical ? h : 2, c: Math.random() < 0.5 ? '34,230,255' : '255,47,208', a: 0.6, t: 0, life: life });
    }
    setTimeout(sliver, rnd(5000, 12000));
  }
  setTimeout(loadArt, 3000);
  setTimeout(sliver, 6500);

  /* ---------- glitchy cursor (mouse only) ---------- */
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var ARROW = 'M3 2 L3 23 L8.5 18 L12.5 27 L16 25.5 L12 16.5 L19 16.5 Z';
  function svg(inner) {
    return 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">' + inner + '</svg>');
  }
  function modern(fill) {
    return svg(
      '<path d="' + ARROW + '" transform="translate(-2 0)" fill="#22e6ff"/>' +
      '<path d="' + ARROW + '" transform="translate(2 1)" fill="#ff2fd0"/>' +
      '<path d="' + ARROW + '" fill="' + fill + '" stroke="#0a0a10" stroke-width="1.5" stroke-linejoin="round"/>');
  }
  var BM = ['X..........','XX.........','XXX........','XXXX.......','XXXXX......','XXXXXX.....','XXXXXXX....','XXXXXXXX...','XXXXXXXXX..','XXXXXXXXXX.','XXXXXX.....','XX.XXX.....','X..XXX.....','....XXX....','....XXX....','.....XX....'];
  function retro(fill) {
    var c = 1.7, out = '<g shape-rendering="crispEdges">', layers = [['#ff2fd0', c * 1.3, c * 1.3, 0], ['#0a0a10', 0, 0, 1], [fill, 0, 0, 0]];
    layers.forEach(function (L) {
      for (var y = 0; y < BM.length; y++) for (var x = 0; x < BM[y].length; x++) {
        if (BM[y].charAt(x) !== 'X') continue;
        var g = L[3] ? 0.9 : 0;
        out += '<rect x="' + (2 + x * c + L[1] - g).toFixed(2) + '" y="' + (2 + y * c + L[2] - g).toFixed(2) + '" width="' + (c + 2 * g).toFixed(2) + '" height="' + (c + 2 * g).toFixed(2) + '" fill="' + L[0] + '"/>';
      }
    });
    return svg(out + '</g>');
  }
  function sliced(fill) {
    return svg(
      '<defs><clipPath id="t"><rect x="0" y="0" width="32" height="13"/></clipPath><clipPath id="b"><rect x="0" y="13" width="32" height="19"/></clipPath></defs>' +
      '<path d="' + ARROW + '" transform="translate(4 0)" clip-path="url(#t)" fill="#22e6ff"/>' +
      '<path d="' + ARROW + '" transform="translate(-3 0)" clip-path="url(#b)" fill="#ff2fd0"/>' +
      '<path d="' + ARROW + '" fill="' + fill + '" stroke="#0a0a10" stroke-width="1.2" stroke-linejoin="round" opacity="0.9"/>');
  }
  var V = [
    { d: modern('#f2efff'), l: modern('#ffe94a') },
    { d: retro('#f2efff'), l: retro('#ffe94a') },
    { d: sliced('#f2efff'), l: sliced('#ffe94a') }
  ];
  var cs = document.createElement('style');
  document.head.appendChild(cs);
  function setCursor(k) {
    var v = V[k];
    cs.textContent =
      'html.gl-cur{cursor:url("' + v.d + '") 3 2,auto}' +
      'html.gl-cur a,html.gl-cur button,html.gl-cur summary,html.gl-cur label,html.gl-cur [role=button],html.gl-cur .cat-card,html.gl-cur .card-wrapper{cursor:url("' + v.l + '") 3 2,pointer}';
  }
  setCursor(0);
  root.classList.add('gl-cur');

  /* every few seconds the cursor stutters through the others, sometimes it sticks on retro for a bit */
  function stutter() {
    var seq = [], n = 2 + Math.floor(Math.random() * 3);
    for (var i = 0; i < n; i++) seq.push(1 + Math.floor(Math.random() * 2));
    var t = 0;
    seq.forEach(function (k) { setTimeout(function () { setCursor(k); }, t); t += rnd(70, 160); });
    var hold = Math.random() < 0.25;
    setTimeout(function () { setCursor(hold ? 1 : 0); }, t);
    if (hold) setTimeout(function () { setCursor(0); }, t + rnd(1500, 2800));
    setTimeout(stutter, t + (hold ? 3500 : 0) + rnd(2500, 6000));
  }
  setTimeout(stutter, 2500);
})();
